















import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { vueCanvasPoster } from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
import QRCode from 'qrcode';
import { getBaseInfo } from '../api';
import { isWeiXin } from '@/common/ts/common';
Vue.use(Popup).use(Button);
@Component({
  components: {
    vueCanvasPoster,
  },
})
export default class Poster extends Vue {
  // @Prop({ required: true }) url!: string;
  baseInfo: any = {};
  detailData: any = {};

  showCanvas = false;
  src = '';
  qrUrl = '';
  painting = {};
  url = '';

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    console.log('base info is:', ret);
    this.$appShareInfo({
      title: '快来参加参加上游新闻“跟帖封神榜”',
      url: location.href,
      subtitle:
        '您的好友邀请您参加上游新闻“跟帖封神榜”活动，快来赢取丰厚奖励吧！',
      classId: -1,
      id: -1,
      image: this.baseInfo.banner,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '快来参加参加上游新闻“跟帖封神榜”',
        subtitle:
          '您的好友邀请您参加上游新闻“跟帖封神榜”活动，快来赢取丰厚奖励吧！',
        image: this.baseInfo.banner,
      });
    }
  }
  mounted() {
    this.url = decodeURIComponent(this.$route.query.inviteUrl as string);
    this.getPainting();
  }

  getPainting() {
    QRCode.toDataURL(
      this.url,
      {
        quality: 1,
        margin: 0,
        scale: 20,
      },
      (err: any, url: string) => {
        if (err) {
          console.log('err occur:', err);
        } else {
          this.qrUrl = url;
        }
      },
    );
    // 开始绘制
    this.painting = {
      width: '675px',
      height: '950px',
      background: '#f4f5f7',
      borderRadius: '20px',
      id: 'cover',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/banner.jpg'),
          css: {
            top: 0,
            left: 0,
            width: '675px',
            height: '333px',
            borderRadius: '20px',
          },
        },
        {
          type: 'image',
          url: this.qrUrl,
          id: 'qr',
          css: {
            top: ['50px', 'cover'],
            left: '337px',
            width: '230px',
            height: '230px',
            mode: 'aspectFill',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'a',
          text: '- 长按识别邀请二维码进行报名',
          css: {
            top: ['450px', 'qr'],
            left: '337px',
            align: 'center',
            color: '#000',
            fontSize: '26px',
          },
        },
        {
          type: 'text',
          id: 'text-b',
          text: '- 点击右上角分享此页面',
          css: {
            top: ['498px', 'qr'],
            left: '337px',
            align: 'center',
            color: '#000',
            fontSize: '26px',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
